const validateCardValidDate = (date: string | undefined) => {
  if (!date) return false;
  const [month, year] = date && date.split('/');

  const currentMonth = new Date().getMonth() + 1;
  const currentYear = parseInt(new Date().getFullYear().toString().slice(-2));

  if (parseInt(year) < currentYear) return false;

  if (parseInt(year) === currentYear && parseInt(month) < currentMonth)
    return false;

  if (parseInt(month) > 12 || parseInt(month) < 1) return false;

  return true;
};

export default validateCardValidDate;
